'use client';
import { twMerge } from 'tailwind-merge';
 import Image from'next/image';

interface LogoProps {
  src: string;
  alt: string;
  variant?: 'header' | 'footer';
  className?: string;
  unoptimized?: boolean;

}

const Logo = ({ 
  src, 
  alt, 
  variant = 'header',
  unoptimized = false, 
  className 
}: LogoProps) => {
  const logoClasses = {
    header: 'w-[70px] sm:w-[100px] md:w-[140px] h-auto',
    footer: 'w-[117px] sm:w-[175px] md:w-[234px] h-auto'
  }

  const dimensions = {
    header: { width: 140, height: 36 },
    footer: { width: 234, height: 58 }
  }

  return (
    <Image data-component-id="src/components/ui/Logo.tsx:32:4" data-component-path="src/components/ui/Logo.tsx" data-component-line="32" data-component-end-line="43" data-component-file="Logo.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%7D"
      src={src}
      alt={alt}
      width={dimensions[variant].width}
      height={dimensions[variant].height}
      className={twMerge(
        logoClasses[variant],
        className
      )}
      priority
      unoptimized={unoptimized} 
    />
  )
}

export default Logo